<div class="bary-address-form">
  <div class="row" [hidden]="!options.withFullName">
    <div class="col-12">
      <jhi-bary-input-text
        [id]="id + 'FullName'"
        [icon]="'id-card'"
        [control]="this.getControl('fullname')"
        [label]="'LABEL.COMPANY_NAME' | translate"
        data-id-cypress="full-name"
      ></jhi-bary-input-text>
    </div>
  </div>
  <div class="row" *ngIf="options.withAutoFill" [hidden]="isAddressNotFound">
    <div class="col-12">
      <jhi-bary-input-gplace
        [addressForm]="addressForm"
        class="mb-0"
        [id]="id + '.autofill'"
        [label]="'LABEL.FIND_MY_ADDRESS_AUTOMATICALLY' | translate"
        [touched]="touched"
        data-id-cypress="address"
      ></jhi-bary-input-gplace>
    </div>
    <div class="col-12">
      <jhi-bary-link (click)="addressNotFound()" [label]="'LABEL.FIND_MY_ADDRESS_MANUALLY' | translate"></jhi-bary-link>
    </div>
  </div>
  <div class="row" [hidden]="!isAddressNotFound">
    <div class="col-3">
      <jhi-bary-input-text [id]="id + '.streetNumber'" [control]="this.getControl('streetNumber')" [label]="'LABEL.STREET_NUMBER' | translate"></jhi-bary-input-text>
    </div>
    <div class="col-9" [hidden]="!options.withAddressNotFoundForm">
      <jhi-bary-input-text [id]="id + '.street'" [control]="this.getControl('street')" [label]="'LABEL.STREET' | translate"></jhi-bary-input-text>
    </div>
  </div>
  <div class="row" [hidden]="!isAddressNotFound">
    <div class="col-3">
      <jhi-bary-input-text [id]="id + '.zipcode'" [control]="this.getControl('zipCode')" [label]="'LABEL.ZIPCODE' | translate"></jhi-bary-input-text>
    </div>
    <div class="col-5">
      <jhi-bary-input-text [id]="id + '.city'" [control]="this.getControl('city')" [label]="'LABEL.CITY' | translate"></jhi-bary-input-text>
    </div>
    <div class="col-4">
      <jhi-bary-input-country [id]="id + '.country'" [control]="this.getControl('country')" [label]="'LABEL.COUNTRY' | translate" [displayField]="'NAME'"></jhi-bary-input-country>
    </div>
  </div>
  <div class="row" *ngIf="options.withFloorNumber">
    <div class="col-12">
      <jhi-bary-input-text [id]="id + '.floorNumber'" [control]="this.getControl('floor')" [label]="'LABEL.FLOOR_NUMBER' | translate"></jhi-bary-input-text>
    </div>
  </div>
  <div class="row" [hidden]="!options.withAdditional">
    <div class="col-12">
      <jhi-bary-input-textarea
        [id]="id + '.additionals'"
        [control]="this.getControl('additionals')"
        [label]="'LABEL.ADDITIONAL_ADDRESS' | translate"
        [rows]="options.rowsForAdditional"
        [maxLength]="getAddressMaxWidth()"
        data-id-cypress="additionals"
      ></jhi-bary-input-textarea>
    </div>
  </div>
  <div class="row" *ngIf="isBillAdressForm()">
    <div class="col-12">
      <jhi-bary-input-email
        [id]="'bill-email'"
        [label]="'LABEL.BILL_EMAIL' | translate"
        [control]="addressForm.controls.billEmail"
      ></jhi-bary-input-email>
    </div>
  </div>
</div>
